export default "__VITE_ASSET__afcdb355__"